<template>
    <CustomDialog
        :showDialog="true"
        :type="'delete'"
        :title="$t('snapBusiness.comment.DeleteCommentConfirm.title')"
        :content="$t('snapBusiness.comment.DeleteCommentConfirm.deleteComment')"
        :confirmText="$t('snapBusiness.comment.DeleteCommentConfirm.delete')"
        @update:showDialog="onCloseHandler"
        @confirm="onActionHandler"
    />
</template>

<script>
import _ from 'lodash';
import CustomDialog from './CustomDialog.vue';

export default {
    components: { CustomDialog },
    props: {
        onCloseHandler: {
            type: Function,
            default: _.noop,
        },
        onActionHandler: {
            type: Function,
            default: _.noop,
        },
    },
    data() {
        return {
            isLoading: false,
        };
    },
    methods: {
        onSubmit() {
            this.isLoading = true;
            this.onActionHandler();
        },
        onCancel() {
            this.onCloseHandler();
        },
    },
};
</script>
